import { z } from "zod";
export const ControlledAiExtractionArtifactV1Schema = z.object({
    schemaVersion: z.literal("controlled-ai-extraction-artifact.v1.0"),
    artifactId: z.string().min(1),
    candidateId: z.string().min(1),
    sourceRef: z.string().min(1),
    modelRef: z.string().min(1),
    promptVersion: z.string().min(1),
    retainedAt: z.string().datetime(),
}).strict();
//# sourceMappingURL=extraction-artifact.js.map